import { render, staticRenderFns } from "./MultiTableUpload.vue?vue&type=template&id=284b8d4a&"
import script from "./MultiTableUpload.vue?vue&type=script&lang=js&"
export * from "./MultiTableUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports